import { Container, type ContainerProps, Stack } from "@mantine/core"
import type { PropsWithChildren, ReactNode } from "react"
import { AppErrorBoundary, AppTitle, Page404, PageLoader } from "../utils"
import { AppHead } from "./AppHead"

interface IProps extends Omit<ContainerProps, "title"> {
  dependency?: boolean
  isLoading?: boolean
  title?: ReactNode
  meta?: {
    title?: string
    description?: string
  }
}

export function Page({ dependency = true, isLoading, children, meta, title, ...props }: PropsWithChildren<IProps>) {
  return (
    <Container size="xl" mih="100vh" {...props}>
      {isLoading && <PageLoader />}
      {meta && <AppHead {...meta} />}
      {dependency ? (
        <Stack py="sm" gap="lg">
          {title && <AppTitle>{title}</AppTitle>}
          <AppErrorBoundary>{children}</AppErrorBoundary>
        </Stack>
      ) : (
        <Page404 />
      )}
    </Container>
  )
}
